import { DragEvent, FC, ReactNode } from 'react';

import { Defect } from '@/types/Defecten';

const ACTIVE_OUTLINE = 'dotted 2px var(--tractie-color-border-selected-default)';

/** True while the drag carries a defect for this mat type (advertised as a DataTransfer type,
 * since the payload itself is unreadable before the drop). */
const acceptsDrag = (event: DragEvent<HTMLElement>, matType: string) =>
  event.dataTransfer.types.includes(matType.toLowerCase());

type OnderhoudDropzoneProps = {
  matType: string;
  onDrop: (defect: Defect) => void;
  children: ReactNode;
};

/** Drop target for dragging a defect from elsewhere in the Plank onto this mat type's
 * "Onderhoud & herstel" column, moving it to onderhoud. */
const OnderhoudDropzone: FC<OnderhoudDropzoneProps> = ({ matType, onDrop, children }) => (
  <div
    data-testid={`${matType}Dropzone`}
    aria-label='dropzone'
    onDragEnter={(event) => {
      event.preventDefault();
      if (!acceptsDrag(event, matType)) {
        event.stopPropagation();
        return;
      }
      event.currentTarget.style.setProperty('outline', ACTIVE_OUTLINE);
    }}
    onDragOver={(event) => {
      event.preventDefault();
      if (!acceptsDrag(event, matType)) {
        event.stopPropagation();
        return;
      }
      if (event.currentTarget.style.outline !== ACTIVE_OUTLINE) {
        event.currentTarget.style.setProperty('outline', ACTIVE_OUTLINE);
      }
    }}
    onDragLeave={(event) => {
      event.preventDefault();
      if (!acceptsDrag(event, matType)) {
        event.stopPropagation();
        return;
      }
      event.currentTarget.style.setProperty('outline', 'solid 0px gray');
    }}
    onDrop={(event) => {
      event.preventDefault();
      if (!acceptsDrag(event, matType)) {
        event.stopPropagation();
        return;
      }
      onDrop(JSON.parse(event.dataTransfer.getData('defect')) as Defect);
      event.currentTarget.style.setProperty('outline', 'dotted 0px var(--tractie-color-border-selected-default)');
      event.currentTarget.style.setProperty('transition', 'outline 0.5 ease-in');
    }}
  >
    {children}
  </div>
);

export default OnderhoudDropzone;
